import React, { useContext, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Login from './pages/Login';
import Layout from './components/UI/Layout';
import Loader from './components/UI/Loader';
import SessionContext from './store/SessionContext';

const Home = React.lazy(() => import('./pages/Home'));
const Movie = React.lazy(() => import('./pages/Movie'));
const Player = React.lazy(() => import('./pages/Player'));
const Error = React.lazy(() => import('./pages/Error'));
const Profile = React.lazy(() => import('./pages/Profile'));

const App = () => {

    const session = useContext(SessionContext);

    return (
        <React.Fragment>
            <Layout>
                <Suspense fallback={<Loader />}>
                    <Switch>
                        <Route path="/" exact>
                            <Redirect to="/home" />
                        </Route>

                        <Route path="/login">
                            {session.isLoggedIn ? <Redirect to='/home' /> : <Login />}
                        </Route>

                        <Route path="/home">
                            {session.isLoggedIn ? <Home /> : <Redirect to='/login' />}
                        </Route>

                        <Route path="/profile">
                            {session.isLoggedIn ? <Profile /> : <Redirect to='/login' />}
                        </Route>

                        <Route path="/player/:movieId">
                            {session.isLoggedIn ? <Player /> : <Redirect to='/login' />}
                        </Route>

                        <Route path="/movie/:movieId">
                            {session.isLoggedIn ? <Movie /> : <Redirect to='/login' />}
                        </Route>

                        <Route path="*">
                            <Error />
                        </Route>
                    </Switch>
                </Suspense>
            </Layout>
        </React.Fragment>
    );
}

export default App;
